var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-tenant-project" },
    [
      _c("TMSHeader", {
        attrs: {
          title: _vm.$t("tenantProjects.createNewProject"),
          buttons: _vm.showBtns,
          status: _vm.status,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("ProjectBasicInformation", {
            ref: "proj-basic-infor",
            attrs: { editable: true },
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("TenantRepresentative", {
            ref: "tenant-representative",
            attrs: { editable: true },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canAccessAllProjects
        ? _c("TermsAndConditions", {
            ref: "tncTenantProjectEditPage",
            attrs: {
              modalId: "tncTenantProjectEditPage",
              acceptCallback: _vm.termsCondtionsCallback,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "submitConfirmModal",
        attrs: {
          modalId: _vm.submitModalId,
          confirmTitle: _vm.$t("confirmSubmit"),
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "createDiffTenancyInfo",
          attrs: { showCloseBtn: false, modalId: "createDiffTenancyInfo" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "font-bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tenantProjects.diffTenancyInfoHint")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeDiffTenancyInfoModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }